/* @refresh reload - deploy trigger */
import { render } from "solid-js/web";
import { Router } from "@solidjs/router";
import { MetaProvider } from "@solidjs/meta";
import { routes } from "./routes";
import "./styles.css";

const root = document.getElementById("root");
if (!root) throw new Error("missing #root");

import { loadSession } from "./lib/auth";

loadSession().finally(() => {
  // Prerender injects a crawlable tree (SsrChrome + article) with data-hk
  // markers. The client shell is different (Router + PublicLayout/Nav), so we
  // must NOT stack a second tree on top of the SSR HTML — that made every
  // marketing page appear twice. Clear prerendered nodes, then mount the SPA.
  // (Crawlers still get full HTML in the first response before JS runs.)
  const hadSsr =
    root.hasAttribute("data-ssr") ||
    root.querySelector("[data-hk]") != null ||
    root.childNodes.length > 0;
  if (hadSsr) {
    root.replaceChildren();
    root.removeAttribute("data-ssr");
  }

  render(
    () => (
      <MetaProvider>
        <Router>{routes}</Router>
      </MetaProvider>
    ),
    root,
  );
});
